<script setup>
import { ref, watch } from 'vue'
import { binder } from '..'
const model = defineModel()
const props = defineProps({
  validate: Function,
  label: String,
  type: String,
  id: String,
  showIf: null,
  showIfNot: null,
  required: [Boolean, null, Number],
  min: [null, Number],
})
const validationRes = ref(null)
watch(
  model,
  mv => {
    if (props.validate instanceof Function) {
      validationRes.value = props.validate(mv)
    }
    if (props.min !== null && mv < props.min) {
      model.value = props.min
    }
  },
  { immediate: true }
)
</script>
<template>
  <input
    v-model="model"
    v-bind="binder"
    class="form-control"
    :class="{ 'is-invalid': validationRes }"
    :id="id"
    :type="type"
  />
  <span v-if="validationRes" class="invalid-feedback">{{ validationRes }}</span>
</template>
